import React from 'react';

export default function TableOfContents({ sections }) {
  if (!sections || sections.length === 0) return null;

  return (
    <nav 
      aria-label="Indholdsfortegnelse" 
      className="my-8 p-4 rounded-[6px] border border-[#DCE3EC] bg-[#E8EEF8]"
    >
      <div className="text-xs font-bold uppercase tracking-wider text-[#2A4DB0] mb-2">
        Indhold på siden
      </div>
      <ul className="space-y-1.5 text-[15px]">
        {sections.map((sec, idx) => (
          <li key={idx}>
            <a 
              href={`#sektion-${idx + 1}`} 
              className="text-[#141B22] hover:text-[#2A4DB0] hover:underline transition-colors flex items-center gap-1.5"
            >
              <span className="text-[#5C6670] text-xs font-mono">{idx + 1}.</span>
              <span>{sec.h2}</span>
            </a>
          </li>
        ))}
        <li>
          <a 
            href="#faq" 
            className="text-[#141B22] hover:text-[#2A4DB0] hover:underline transition-colors flex items-center gap-1.5"
          >
            <span className="text-[#5C6670] text-xs font-mono">{sections.length + 1}.</span>
            <span>Ofte stillede spørgsmål</span>
          </a>
        </li>
        <li>
          <a 
            href="#kilder" 
            className="text-[#141B22] hover:text-[#2A4DB0] hover:underline transition-colors flex items-center gap-1.5"
          >
            <span className="text-[#5C6670] text-xs font-mono">{sections.length + 2}.</span>
            <span>Kilder</span>
          </a>
        </li>
      </ul>
    </nav>
  );
}
